import disableBodyScroll from "../util/disableBodyScroll";
var supportsOrientationChange = ("onorientationchange" in window),
  orientationEvent = supportsOrientationChange ? "orientationchange" : "resize";
var Filter = {};
Filter.toggle = function () {
  var openFilter = $(".js-filter-open");
  var closeFilter = $(".js-filter-close");
  var openFilterButtons = $(".filter-open");
  var closeFilterButtons = $(".filter-close");
  var collapseFilter = $(".js-filter-collapse");
  openFilter.click(function () {
    collapseFilter.show();
    openFilterButtons.removeClass("show").addClass("hide");
    closeFilterButtons.removeClass("hide").addClass("show");
    if (matchMedia("screen and (max-width: 991.98px)").matches) {
      $("body").addClass("filter-is-open");
      disableBodyScroll(true, ".product-filter");
    }
  });
  closeFilter.click(function () {
    collapseFilter.hide();
    closeFilterButtons.removeClass("show").addClass("hide");
    openFilterButtons.removeClass("hide").addClass("show");
    if (matchMedia("screen and (max-width: 991.98px)").matches) {
      $("body").removeClass("filter-is-open");
      disableBodyScroll(false, ".product-filter");
      if ($("section.product-listing").length) {
        $("html, body").animate({
          scrollTop: $(".section.product-listing").first().offset().top
        }, 1000);
      }
    }
  });
  if ($(".product-filter")[0]) {
    window.addEventListener(orientationEvent, function () {
      collapseFilter.hide();
      closeFilterButtons.removeClass("show").addClass("hide");
      openFilterButtons.removeClass("hide").addClass("show");
    }, false);
  }
};
Filter.accordion = function () {
  var toggleAccordion = $(".js-accordion-toggle");
  var accordionBody = $(".js-accordion-body");
  toggleAccordion.click(function () {
    var thisAccordion = $(this);
    if (thisAccordion.hasClass("is-open")) {
      thisAccordion.siblings(accordionBody).removeClass("is-open");
      thisAccordion.removeClass("is-open");
    } else {
      thisAccordion.siblings(accordionBody).addClass("is-open");
      thisAccordion.addClass("is-open");
    }
  });
};
Filter.toggle();
Filter.accordion();


// WEBPACK FOOTER //
// ./scripts/components/filter.js